import gql from 'graphql-tag';
import { observable, action } from 'mobx';

const resultsQuery = gql`
        query ResultsQuery(
            $URLID: String!
        ) {
            readResult(
                URLID: $URLID
            ) {
                ResultsSection1Title
                ResultsSection1ResultContent1
                ResultsSection1ResultContent2
                ResultsRetrofitted2009Content
                ResultsSection2Title
                ResultsSection2Content
                ResultsSection3Title
                ResultsSection3Content
                ResultsSection4Title
                ResultsSection4Content
                ResultsSection5Title
                ResultsSection5Content
                EmailReportInformation
                Result
                Error
            }
        }
    `,

    emailMutation = gql`
        mutation EmailMutation(
            $URLID: String!
            $SecurityID: String!
            $PDF: Boolean!
            $Name: String!
            $LandlordName: String!
            $Address: String!
            $Email: String!
            $Role: String!
        ) {
            toolEmailMutation(
                URLID: $URLID
                SecurityID: $SecurityID
                PDF: $PDF
                Name: $Name
                LandlordName: $LandlordName
                Address: $Address
                Email: $Email
                Role: $Role
            ) {
                URLID
                Error
            }
        }
    `;
// $EmailVerify: String!

export class ResultsStore {
    appStore;

    @observable page = false;

    @observable loading = true;

    @observable reportLoading = false;

    @observable error = false;

    @observable reportError = false;

    @observable reportSuccess = false;

    @action reset() {
        this.page = [];
        this.loading = true;
        this.reportLoading = false;
        this.error = false;
        this.reportError = false;
    }

    constructor(opts) {
        this.appStore = opts.appStore;
    }

    async initializeResults() {
        this.loading = true;
        this.error = false;

        const result = await this.appStore.apolloClient
            .query({
                query: resultsQuery,
                variables: {
                    URLID: this.appStore.submissionID
                },
                fetchPolicy: 'network-only'
            })
            .catch(result => {
                this.handleServerError(result);
            });

        if (result && result.data.readResult) {
            const data = result.data.readResult;
            if (data.Error) {
                this.error = JSON.parse(data.Error);
            } else {
                this.page = data;
                this.page.Result = JSON.parse(data.Result);
            }

            // prevent flash of loader for fast API's
            setTimeout(() => {
                this.loading = false;
            }, 300);
        } else {
            this.page = false;
            this.loading = false;
        }
    }

    handleServerError(result, errorType = 'error') {
        if (result.graphQLErrors) {
            const errors = result.graphQLErrors.map(error => error.message);
            this[errorType] = {
                message: errors.join(', '),
                code: 500
            };
        } else if (result.networkError) {
            this[errorType] = {
                message: result.networkError,
                code: 500
            };
        } else {
            this[errorType] = {
                message: result,
                code: 500
            };
        }

        this.loading = false;
        this.reportLoading = false;
    }

    async emailReport(values, form) {
        this.reportLoading = true;
        this.reportSuccess = false;
        this.reportError = false;
        this.reportCode = false;

        const result = await this.appStore.apolloClient
            .mutate({
                mutation: emailMutation,
                variables: {
                    URLID: this.appStore.submissionID,
                    SecurityID: this.appStore.sectoken,
                    PDF: true,
                    ...values
                },
                fetchPolicy: 'no-cache',
                context: {
                    headers: {
                        'X-CSRF-TOKEN': this.appStore.sectoken
                    }
                }
            })
            .catch(result => {
                this.handleServerError(result, 'resultError');
            });

        if (result) {
            const data = result.data.toolEmailMutation;
            if (data.Error) {
                this.reportError = JSON.parse(data.Error);
            } else if (result.data.toolEmailMutation.URLID) {
                this.reportSuccess = values.Email;
            } else {
                this.reportError = {
                    message: 'Could not send report',
                    code: 500
                };
            }

            // prevent flash of loader for fast API's
            setTimeout(() => {
                this.reportLoading = false;
            }, 300);
        } else {
            this.reportSuccess = false;
            this.reportLoading = false;
        }
    }
};
